import constantFactory from "@gaoding/constant-factory";

export const { REPORT, REPORT_LIST, REPORT_MAP, REPORT_ITEM_MAP } =
  constantFactory("REPORT", [
    {
      key: "SPAM",
      label: "垃圾广告",
      value: 0,
    },
    {
      key: "PORN_VULGAR",
      label: "色情低俗",
      value: 1,
    },
    {
      key: "FRAUD",
      label: "涉嫌诈骗",
      value: 2,
    },
    // {
    //   key: "SENSITIVE",
    //   label: "敏感信息",
    //   value: 3,
    // },
    {
      key: "ATTACK",
      label: "人身攻击",
      value: 4,
    },
    // {
    //   key: "HARASS",
    //   label: "骚扰他人",
    //   value: 5,
    // },
    // {
    //   key: "INFRINGEMENT",
    //   label: "侵权",
    //   value: 6,
    // },
    // {
    //   key: "DISLIKE",
    //   label: "我不喜欢",
    //   value: 7,
    // },
    {
      key: "FALSE_INFO",
      label: "虚假、错误信息",
      value: 8,
    },
    {
      key: "PRIVACY_INFRINGEMENT",
      label: "侵犯隐私",
      value: 9,
    },
    {
      key: "MINOR_INAPPROPRIATE",
      label: "涉未成年人不当内容",
      value: 10,
    },
    {
      key: "POLITICAL_SENSITIVE",
      label: "政治敏感",
      value: 11,
    },
    {
      key: "VIOLENCE",
      label: "暴力",
      value: 12,
    },
    // {
    //   key: "OTHER",
    //   label: "其他原因",
    //   value: 99,
    // },
  ]);
